import {
	IonButton,
	IonCardTitle,
	IonCol,
	IonGrid,
	IonInput,
	IonItem,
	IonLabel,
	IonRow,
	IonSearchbar,
	IonSelect,
	IonSelectOption,
} from "@ionic/react";
import { useEffect, useState } from "react";
import UserCard from "./UserCard";
import AddUserModal from "./AddUserModal-UNUSED";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import Spacer from "../../../components/spacer";
import { setCurrentView } from "../../../services/users";

interface props {
	usersData: any;
	setCurrentView: any;
}

const UserList: React.FC<props> = ({ usersData, setCurrentView }) => {
	const history = useHistory();
	const [users, setUsers] = useState<any>([]);
	const [filteredUsers, setFilteredUsers] = useState<any>([]);
	const [modalOpen, setModalOpen] = useState<any>(false);
	const [roleFilter, setRoleFilter] = useState<any>("all");
	const [searchText, setSearchText] = useState<any>("");

	useEffect(() => {
		setCurrentView("");
		setUsers(usersData);
		//console.log(usersData);
	}, [usersData]);

	useEffect(() => {
		let filtered = Object.values(users).filter((el: any) => {
			if (
				roleFilter === "all" ||
				el.role === roleFilter ||
				el.study === roleFilter
			) {
				if (searchText.length > 0) {
					let name = el.displayName.toLowerCase();
					if (name.search(searchText.toLowerCase()) !== -1) {
						return true;
					}
				} else return true;
			}

			return false;
		});
		setFilteredUsers(filtered);
	}, [users, roleFilter, searchText]);

	const _addUser = () => {
		history.push("/users/new/config");
	};

	// useEffect(() => {
	// 	console.log(roleFilter);
	// }, [roleFilter]);

	// useEffect(() => {
	// 	console.log(searchText);
	// }, [searchText]);

	const _compareRoleFilter = (o1: any, o2: any) => {
		return o1 === roleFilter;
	};

	const _onSelect = (e: any) => {
		let name = e.target.name;
		let value = e.target.value;

		if (name === "roleFilter") {
			setRoleFilter(value);
		}
	};

	return (
		<>
			<IonItem>
				<h1>Users</h1>
				<IonButton slot="end" onClick={_addUser}>
					Add User
				</IonButton>
			</IonItem>
			<IonGrid>
				<Spacer size="30" />
				<IonRow>
					<IonCol sizeLg="4" sizeMd="6" sizeXs="12">
						<IonItem>
							<IonLabel position="stacked">Filter</IonLabel>
							<IonSelect
								compareWith={_compareRoleFilter}
								id="roleFilter"
								name="roleFilter"
								value={roleFilter}
								onIonChange={_onSelect}
								okText="Okay"
								cancelText="Dismiss"
								placeholder="Select One"
								interface="popover"
							>
								<IonSelectOption value="all">All</IonSelectOption>
								<IonSelectOption value="admin">Admininstrators</IonSelectOption>
								<IonSelectOption value="sleep">
									Sleep Participants
								</IonSelectOption>
								<IonSelectOption value="eat">
									Eating Participants
								</IonSelectOption>
								<IonSelectOption value="toilet">
									Toileting Participants
								</IonSelectOption>
							</IonSelect>
						</IonItem>
					</IonCol>
					<IonCol sizeLg="8" sizeMd="6" sizeXs="12">
						<IonSearchbar
							value={searchText}
							animated
							debounce={1000}
							onIonChange={(e) => setSearchText(e.detail.value!)}
							placeholder="Search by name/code"
						></IonSearchbar>
					</IonCol>
				</IonRow>
			</IonGrid>

			<Spacer size="30" />
			<AddUserModal modalOpen={modalOpen} setModalOpen={setModalOpen} />
			<div>
				{filteredUsers &&
					Object.values(filteredUsers).map((user: any, idx: any) => (
						<UserCard key={idx} user={user} />
					))}
				{filteredUsers.length === 0 && <span>No users found</span>}
			</div>
		</>
	);
};

const mapDispatchToProps = { setCurrentView };

const mapStateToProps = (state: any) => ({
	usersData: state.user.users,
});

export default connect(mapStateToProps, mapDispatchToProps)(UserList);
